import React from "react";
import PropTypes from "prop-types";

import { Section, Title } from "./styles";
import LegacyPrepaidWarning from "core/PrepaidWarning/LegacyPrepaidWarning";

import { convertCentsToDollars } from "frontend/components/helpers";

const PrepaidBalance = ({ totalPrepaidBalanceAvailableCents }) => {
    const amount = convertCentsToDollars(totalPrepaidBalanceAvailableCents);

    return (
        <Section>
            <Title>Prepaid Remaining Balance</Title>
            <div>${amount}</div>
            <LegacyPrepaidWarning />
        </Section>
    );
};

PrepaidBalance.propTypes = {
    totalPrepaidBalanceAvailableCents: PropTypes.number
};

export default PrepaidBalance;
